export default {
  isToggle: false,
  artworks: {},
  artworkCounter: 0,
}
